import { render, staticRenderFns } from "./UnconsumedBugetReport.vue?vue&type=template&id=5f6131ee&"
import script from "./UnconsumedBugetReport.vue?vue&type=script&lang=js&"
export * from "./UnconsumedBugetReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports